import { render, staticRenderFns } from "./sportBetsTable.vue?vue&type=template&id=167aca9f&"
import script from "./sportBetsTable.vue?vue&type=script&lang=js&"
export * from "./sportBetsTable.vue?vue&type=script&lang=js&"
import style0 from "./sportBetsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sportBetsTable.vue"
export default component.exports